//import React from 'react';

export default class PricingStatusChangeItem {
  constructor(item) {
    //Item has to be PricingistItem
    this.PricingId = item === undefined ? '' : item.PricingId;
    this.Action = '';
    this.Comment = '';
    this.Selected = false;
    this.ServiceHasApprovedPricingForThisCountry = item.ServiceHasApprovedPricingForThisCountry;
  }
}
